/* eslint-disable no-plusplus */
function validateCPF(cpf: string): boolean {
  if (!cpf) return false;

  const newCPF = cpf.replace(/[^\d]+/g, '');

  if (newCPF === '') return false;
  if (
    newCPF.length !== 11 ||
    newCPF === '00000000000' ||
    newCPF === '11111111111' ||
    newCPF === '22222222222' ||
    newCPF === '33333333333' ||
    newCPF === '44444444444' ||
    newCPF === '55555555555' ||
    newCPF === '66666666666' ||
    newCPF === '77777777777' ||
    newCPF === '88888888888' ||
    newCPF === '99999999999'
  )
    return false;
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(newCPF.charAt(i), 10) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(newCPF.charAt(9), 10)) return false;
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(newCPF.charAt(i), 10) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(newCPF.charAt(10), 10)) return false;
  return true;
}

export default validateCPF;
